import {
    GET_PERIODS_ACTION_REQUEST,
    GET_PERIODS_ACTION_SUCCESS,
    GET_PERIODS_ACTION_FAILURE,
    SET_PERIOD_ACTION,
    LOCK_PERIOD_ACTION_SUCCESS,
    LOCK_PERIOD_ACTION_FAILURE,
    UNLOCK_PERIOD_ACTION_SUCCESS,
    UNLOCK_PERIOD_ACTION_FAILURE,
    OPEN_PERIOD_ACTION_SUCCESS,
    PERIOD_SEND_NOTIFICATION_CLEAR
} from './constants';

import {
    Period,
    GetPeriodsActionRequest,
    GetPeriodsActionSuccess,
    GetPeriodsActionFailure,
    SetPeriodAction,
    LockPeriodSuccess,
    UnlockPeriodSuccess,
    OpenPeriodSuccess
} from './typedef';

type IActions = GetPeriodsActionRequest &
    GetPeriodsActionSuccess &
    GetPeriodsActionFailure &
    SetPeriodAction &
    LockPeriodSuccess &
    UnlockPeriodSuccess &
    OpenPeriodSuccess;

interface State {
    current: Period | null;
    calendar: Period | null;
    list: Period[] | null;
}

const defaultState = {
    current: null,
    calendar: null,
    list: null
};

const periods = (state: State = defaultState, action: IActions) => {
    switch (action.type) {
        case GET_PERIODS_ACTION_REQUEST:
            return {
                ...state,
                current: null,
                calendar: null,
                list: null
            };
        case GET_PERIODS_ACTION_SUCCESS:
            return {
                ...state,
                current: action.current,
                calendar: action.current,
                list: action.list
            };
        case GET_PERIODS_ACTION_FAILURE:
            return {
                ...state
            };
        case SET_PERIOD_ACTION:
            return {
                ...state,
                calendar: action.data
            };
        case LOCK_PERIOD_ACTION_SUCCESS: {
            const newPeriodsWithLock: Period[] | null =
                state.list &&
                state.list.map((period: Period) => {
                    return period.id === action.period.id ? action.period : period;
                });
            return {
                ...state,
                current: state.current && state.current.id === action.period.id ? action.period : state.current,
                calendar: action.period,
                list: newPeriodsWithLock,
                periodSuccess: true
            };
        }
        case LOCK_PERIOD_ACTION_FAILURE:
            return {
                ...state,
                stateError: true
            };
        case UNLOCK_PERIOD_ACTION_SUCCESS: {
            const newPeriodsWithUnlock: Period[] | null =
                state.list &&
                state.list.map((period: Period) => {
                    return period.id === action.period.id ? action.period : period;
                });
            return {
                ...state,
                current: state.current && state.current.id === action.period.id ? action.period : state.current,
                calendar: action.period,
                list: newPeriodsWithUnlock,
                periodSuccess: true
            };
        }
        case UNLOCK_PERIOD_ACTION_FAILURE:
            return {
                ...state,
                stateError: true
            };
        case OPEN_PERIOD_ACTION_SUCCESS: {
            const newPeriods: Period[] | null =
                state.list &&
                state.list.map((period: Period) => {
                    if (period.id !== action.current.id) {
                        period.locked = true;
                    }
                    return period;
                });
            return {
                ...state,
                current: action.current,
                calendar: action.current,
                list: newPeriods
            };
        }
        case PERIOD_SEND_NOTIFICATION_CLEAR:
            return {
                ...state,
                periodError: false,
                periodSuccess: false
            };
        default:
            return state;
    }
};

export {periods};
